import moment from 'moment';

import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { downloadFile } from 'actions/common';

export const GET_MI_DASHBOARD_XLS_REQUEST = 'GET_MI_DASHBOARD_XLS_REQUEST';
export const GET_MI_DASHBOARD_XLS_SUCCESS = 'GET_MI_DASHBOARD_XLS_SUCCESS';
export const GET_MI_DASHBOARD_XLS_FAILURE = 'GET_MI_DASHBOARD_XLS_FAILURE';

function requestMiDashboardXls() {
  return {
    type: GET_MI_DASHBOARD_XLS_REQUEST,
    isGettingMiDashboardXls: true
  };
}

function receiveMiDashboardXls(miData) {
  return {
    type: GET_MI_DASHBOARD_XLS_SUCCESS,
    isGettingMiDashboardXls: false,
    miData
  };
}

function rejectMiDashboardXls() {
  return {
    type: GET_MI_DASHBOARD_XLS_FAILURE,
    isGettingMiDashboardXls: false,
    miData: null
  };
}

export function getMiDashboardXls(clientId, fromDate, toDate, trend) {
  return (dispatch) => {
    dispatch(requestMiDashboardXls());

    const promise = () => ApiService
      .getMiDashboardXls(clientId, fromDate, toDate, trend, { responseType: 'arraybuffer' })
      .then((response) => {
        dispatch(receiveMiDashboardXls(response.data));
        return dispatch(
          downloadFile(
            response.data,
            `${ moment().format('DD_MMM_YYYY') }_dashboard.xlsx`,
            'application/xls'
          )
        );
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          if (error.response) {
            error.response.data = { code: error.response.status, message: 'Sorry, we were unable to generate your excel report at this time, please come back later' };
          }
          dispatch(handleException(error, rejectMiDashboardXls, true));
        }
      });
    return promise();
  };
}
